import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  InputFrom: FormGroup;//สร้างกลุ่ม Object Data
  constructor(
    private formBuilder: FormBuilder,
    private Swal: SWAlertService,
    private http: HttpClient,
    private router: Router,
    private System: TSFuntionService,
    private Authen: AuthService,
  ) { }

  ngOnInit() {
    this.System.RemoveUserStorage(); 
    this.System.OnFocus("txtUserName", "btnLogin");
    this.System.OnFocus("txtPassword", "btnLogin");
    this.InputFrom = this.formBuilder.group({
      sUsername: ["", Validators.required],
      sPassword: ["", Validators.required]
    });
    this.System.ClearTimeInterval();
    
  }

  ExportUniversal(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    return this.http.post<any>(this.System.SiteName + "api/ExportUniversal/GenerateUniversal", { httpOptions, responseType: 'blob' }).subscribe(res => {
    });
  }

  onSubmit() {
    // stop here if form is invalid
    if (this.InputFrom.invalid) {
      this.validateAllFormFields(this.InputFrom); //{7}
      return;
    }
    else {
      this.System.BlockUI();
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      let formObj = this.InputFrom.getRawValue(); // 
      let ITEM = JSON.stringify(formObj);
      this.http.post(this.System.SiteName + "api/_System/Login", ITEM, { headers, responseType: 'text' }).subscribe(res => {
        if (res) {
          this.System.UnBlockUI();
          this.Swal.SwAlert.Error(this.Swal.BoxMsg.Title_Warning, res, function () { Swal.close(); });
        }
        else {
          this.System.UserLogin();
        }
      });
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  isFieldValid(field: string) {
    return !this.InputFrom.get(field).valid && this.InputFrom.get(field).touched;
  }
  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }
  onClick(value: string) {
    let _this = this;
    switch (value) {
      case "ChangePassword":
        this.router.navigate(["/changepassword"]);
        break;
      case "ForgetPassword":
        this.router.navigate(["/forgetpassword"]);
        break;
      case "SetupRecieveMail":
        this.router.navigate(["/setuprecievemail"]);
        break;
      case "ContactWeb":
        var mail = document.createElement("a");
        mail.href = "mailto:";
        mail.click();
        break;
      default:
    }
  }
}
